import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    convertStartEndDatesForFile,
    getItemFromArray,
    toCurrency,
} from '../shared/functions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from "material-ui/FlatButton";
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import TableIcon from 'material-ui/svg-icons/device/access-time';

const styles = {
    tRow: {
        currency: {background: '#ffffff'},
        subtotals: {background: '#ffffff'},
        tax: {background: '#e6ebf0'},
        totals: {background: '#e6ebf0'},
    },
    tRowLast: {borderBottom: '4px solid #999'},
};

/**
 * Class for displaying Bihourly Sales Summary data in a single table
 *
 */
class SalesSummaryBihourlyReportTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {key: 'name', label: ''},
                {key: 'hour_0-2', label: '12am - 2am'},
                {key: 'hour_2-4', label: '2am - 4am'},
                {key: 'hour_4-6', label: '4am - 6am'},
                {key: 'hour_6-8', label: '6am - 8am'},
                {key: 'hour_8-10', label: '8am - 10am'},
                {key: 'hour_10-12', label: '10am - 12pm'},
                {key: 'hour_12-14', label: '12pm - 2pm'},
                {key: 'hour_14-16', label: '2pm - 4pm'},
                {key: 'hour_16-18', label: '4pm - 6pm'},
                {key: 'hour_18-20', label: '6pm - 8pm'},
                {key: 'hour_20-22', label: '8pm - 10pm'},
                {key: 'hour_22-24', label: '10pm - 12am'}
            ],
            message: null,
            summaryComplete: false,
        };
        this.handleExportClick = this.handleExportClick.bind(this);
    }

    componentWillMount() {
        this.processData(this.props.dataObject);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dataObject !== this.props.dataObject) {
            this.setState({
                summaryList: [],
                summaryComplete: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dataObject !== this.props.dataObject) {
            this.processData(this.props.dataObject);
        }
    }

    /* Data Processing ------------------------------ */

    /**
     * Arrange data for use by table
     *
     * @param dataObject
     */
    processData(dataObject) {

        const emptyCurrency = toCurrency(0);
        let summaryList = [];

        // Get a numerical value for the time zone offset
        let offsetArr = this.props.offset.split(':');
        let offsetHrs = parseInt(offsetArr[0], 10);

        if (dataObject) {

            // Set an array of hourly slots for a day
            const timeSlots = [
                {id: 0, label: '12', suffix: 'am', slot: {}},
                {id: 1, label: '1', suffix: 'am', slot: {}},
                {id: 2, label: '2', suffix: 'am', slot: {}},
                {id: 3, label: '3', suffix: 'am', slot: {}},
                {id: 4, label: '4', suffix: 'am', slot: {}},
                {id: 5, label: '5', suffix: 'am', slot: {}},
                {id: 6, label: '6', suffix: 'am', slot: {}},
                {id: 7, label: '7', suffix: 'am', slot: {}},
                {id: 8, label: '8', suffix: 'am', slot: {}},
                {id: 9, label: '9', suffix: 'am', slot: {}},
                {id: 10, label: '10', suffix: 'am', slot: {}},
                {id: 11, label: '11', suffix: 'am', slot: {}},
                {id: 12, label: '12', suffix: 'pm', slot: {}},
                {id: 13, label: '1', suffix: 'pm', slot: {}},
                {id: 14, label: '2', suffix: 'pm', slot: {}},
                {id: 15, label: '3', suffix: 'pm', slot: {}},
                {id: 16, label: '4', suffix: 'pm', slot: {}},
                {id: 17, label: '5', suffix: 'pm', slot: {}},
                {id: 18, label: '6', suffix: 'pm', slot: {}},
                {id: 19, label: '7', suffix: 'pm', slot: {}},
                {id: 20, label: '8', suffix: 'pm', slot: {}},
                {id: 21, label: '9', suffix: 'pm', slot: {}},
                {id: 22, label: '10', suffix: 'pm', slot: {}},
                {id: 23, label: '11', suffix: 'pm', slot: {}}
            ];

            // Update time array with hourly data offset by selected time zone offset
            for (let i = 0; i < timeSlots.length; i++) {
                // Calculate time zone offset in the available hours
                let offsetIndex = (i - offsetHrs);
                if (offsetIndex < 0) {
                    offsetIndex = offsetIndex + 24;
                }
                if (offsetIndex > 23) {
                    offsetIndex = offsetIndex - 24;
                }
                // Get the desired data from the offset hour
                let dataItem = dataObject['hour_' + offsetIndex + '_UTC'];
                if (dataItem) {
                    // Update the time array
                    timeSlots[i].slot = dataItem;
                }
            }

            // Create columns of bihourly slots to be populated with aggregated hourly data
            const columnSlots = [
                'hour_0-2',
                'hour_2-4',
                'hour_4-6',
                'hour_6-8',
                'hour_8-10',
                'hour_10-12',
                'hour_12-14',
                'hour_14-16',
                'hour_16-18',
                'hour_18-20',
                'hour_20-22',
                'hour_22-24'
            ];
            let columnSlotsLength = columnSlots.length;

            // Set list of rows to assemble
            const rows = [
                {series: 'totals', id: 'total_payments', name: '# Payments', is_last: false},
                {series: 'totals', id: 'total_credits', name: '# Credits', is_last: true},
                {series: 'subtotals', id: 'subtotal_average', name: 'Avg Subtotal', is_last: false},
                {series: 'subtotals', id: 'subtotal_max', name: 'Max Subtotal', is_last: false},
                {series: 'subtotals', id: 'subtotal_min', name: 'Min Subtotal', is_last: true},
                {series: 'tax', id: 'tax_average', name: 'Avg Tax', is_last: false},
                {series: 'tax', id: 'tax_max', name: 'Max Tax', is_last: false},
                {series: 'tax', id: 'tax_min', name: 'Min Tax', is_last: true},
                {series: 'currency', id: 'total_average', name: 'Avg Total', is_last: false},
                {series: 'currency', id: 'total_max', name: 'Max Total', is_last: false},
                {series: 'currency', id: 'total_min', name: 'Min Total', is_last: false}
            ];
            let rowLength = rows.length;

            // Create all named rows
            for (let r = 0; r < rowLength; r++) {

                // Create row
                const row = {
                    id: rows[r].id,
                    name: rows[r].name,
                    series: rows[r].series,
                    is_last: rows[r].is_last
                };

                // Populate each bihourly column with added hourly data
                let inc = 0;
                for (let c = 0; c < columnSlotsLength; c++) {

                    // Retrieve the current slot and the following hour (ex: 2-4 includes hour 2 and hour 3)
                    let hour1 = getItemFromArray(timeSlots, 'id', inc);
                    let hour2 = getItemFromArray(timeSlots, 'id', (inc + 1));
                    let slot1 = hour1.slot;
                    let slot2 = hour2.slot;

                    // Set credit and payment objects
                    let c1 = slot1.credit_count;
                    let c2 = slot2.credit_count;
                    let p1 = slot1.payment_count;
                    let p2 = slot2.payment_count;
                    let key = columnSlots[c];

                    // Payment count is used for several columns and calculating averages
                    let total_payments1 = (p1 && p1.doc_count) ? p1.doc_count : 0;
                    let total_payments2 = (p2 && p2.doc_count) ? p2.doc_count : 0;
                    let total_payments = total_payments1 + total_payments2;

                    // Populate this column with the data appropriate to the row
                    // Counts, Subtotals, Tax, Totals
                    if (row.id === 'total_payments') {
                        row[key] = total_payments;
                    } else if (row.id === 'total_credits') {
                        let tc1 = (c1 && c1.doc_count) ? c1.doc_count : 0;
                        let tc2 = (c2 && c2.doc_count) ? c2.doc_count : 0;
                        row[key] = tc1 + tc2;

                    } else if (row.id === 'subtotal_average') {
                        // Calculate averages from sums / payments (data averages cannot be used)
                        let subsum1 = (p1 && p1.subtotal_stats && p1.subtotal_stats.sum) ? p1.subtotal_stats.sum : 0;
                        let subsum2 = (p2 && p2.subtotal_stats && p2.subtotal_stats.sum) ? p2.subtotal_stats.sum : 0;
                        let subsums = subsum1 + subsum2;
                        let subaverage = (subsums > 0 && total_payments > 0) ? (subsum1 + subsum2) / (total_payments1 + total_payments2) : 0;
                        row[key] = (subaverage) ? toCurrency(subaverage / 100) : emptyCurrency;
                    } else if (row.id === 'subtotal_max') {
                        let submax1 = (p1 && p1.subtotal_stats && p1.subtotal_stats.max) ? p1.subtotal_stats.max : 0;
                        let submax2 = (p2 && p2.subtotal_stats && p2.subtotal_stats.max) ? p2.subtotal_stats.max : 0;
                        row[key] = ((submax1 + submax2) > 0) ? toCurrency((submax1 + submax2) / 100) : emptyCurrency;
                    } else if (row.id === 'subtotal_min') {
                        let submin1 = (p1 && p1.subtotal_stats && p1.subtotal_stats.min) ? p1.subtotal_stats.min : 0;
                        let submin2 = (p2 && p2.subtotal_stats && p2.subtotal_stats.min) ? p2.subtotal_stats.min : 0;
                        row[key] = ((submin1 + submin2) > 0) ? toCurrency((submin1 + submin2) / 100) : emptyCurrency;

                    } else if (row.id === 'tax_average') {
                        // Calculate averages from sums / payments (data averages cannot be used)
                        let taxsum1 = (p1 && p1.tax_stats && p1.tax_stats.sum) ? p1.tax_stats.sum : 0;
                        let taxsum2 = (p2 && p2.tax_stats && p2.tax_stats.sum) ? p2.tax_stats.sum : 0;
                        let additionaltaxsum1 = (p1 && p1.additional_tax_stats && p1.additional_tax_stats.sum) ? p1.additional_tax_stats.sum : 0;
                        let additionaltaxsum2 = (p2 && p2.additional_tax_stats && p2.additional_tax_stats.sum) ? p2.additional_tax_stats.sum : 0;
                        let taxsums = taxsum1 + taxsum2 + additionaltaxsum1 + additionaltaxsum2;
                        let taxaverage = (taxsums > 0 && total_payments > 0) ? (taxsum1 + taxsum2 + additionaltaxsum1 + additionaltaxsum2) / (total_payments1 + total_payments2) : 0;
                        row[key] = (taxaverage) ? toCurrency(taxaverage / 100) : emptyCurrency;
                    } else if (row.id === 'tax_max') {
                        let taxmax1 = (p1 && p1.tax_stats && p1.tax_stats.max) ? p1.tax_stats.max : 0;
                        let taxmax2 = (p2 && p2.tax_stats && p2.tax_stats.max) ? p2.tax_stats.max : 0;
                        let additionaltaxmax1 = (p1 && p1.additional_tax_stats && p1.additional_tax_stats.max) ? p1.additional_tax_stats.max : 0;
                        let additionaltaxmax2 = (p2 && p2.additional_tax_stats && p2.additional_tax_stats.max) ? p2.additional_tax_stats.max : 0;
                        row[key] = ((taxmax1 + taxmax2 + additionaltaxmax1 + additionaltaxmax2) > 0) ? toCurrency((taxmax1 + taxmax2 + additionaltaxmax1 + additionaltaxmax2) / 100) : emptyCurrency;
                    } else if (row.id === 'tax_min') {
                        let taxmin1 = (p1 && p1.tax_stats && p1.tax_stats.min) ? p1.tax_stats.min : 0;
                        let taxmin2 = (p2 && p2.tax_stats && p2.tax_stats.min) ? p2.tax_stats.min : 0;
                        let additionaltaxmin1 = (p1 && p1.additional_tax_stats && p1.additional_tax_stats.min) ? p1.additional_tax_stats.min : 0;
                        let additionaltaxmin2 = (p2 && p2.additional_tax_stats && p2.additional_tax_stats.min) ? p2.additional_tax_stats.min : 0;
                        row[key] = ((taxmin1 + taxmin2 + additionaltaxmin1 + additionaltaxmin2) > 0) ? toCurrency((taxmin1 + taxmin2 + additionaltaxmin1 + additionaltaxmin2) / 100) : emptyCurrency;

                    } else if (row.id === 'total_average') {
                        // Calculate averages from sums / payments (data averages cannot be used)
                        let totsum1 = (p1 && p1.currency_stats && p1.currency_stats.sum) ? p1.currency_stats.sum : 0;
                        let totsum2 = (p2 && p2.currency_stats && p2.currency_stats.sum) ? p2.currency_stats.sum : 0;
                        let totsums = totsum1 + totsum2;
                        let totaverage = (totsums > 0 && total_payments > 0) ? (totsum1 + totsum2) / (total_payments1 + total_payments2) : 0;
                        row[key] = (totaverage) ? toCurrency(totaverage / 100) : emptyCurrency;
                    } else if (row.id === 'total_max') {
                        let totmax1 = (p1 && p1.currency_stats && p1.currency_stats.max) ? p1.currency_stats.max : 0;
                        let totmax2 = (p2 && p2.currency_stats && p2.currency_stats.max) ? p2.currency_stats.max : 0;
                        row[key] = ((totmax1 + totmax2) > 0) ? toCurrency((totmax1 + totmax2) / 100) : emptyCurrency;
                    } else if (row.id === 'total_min') {
                        let totmin1 = (p1 && p1.currency_stats && p1.currency_stats.min) ? p1.currency_stats.min : 0;
                        let totmin2 = (p2 && p2.currency_stats && p2.currency_stats.min) ? p2.currency_stats.min : 0;
                        row[key] = ((totmin1 + totmin2) > 0) ? toCurrency((totmin1 + totmin2) / 100) : emptyCurrency;
                    }

                    inc += 2;
                }
                summaryList.push(row);
            }
        }

        // Finalize table data
        this.setState({
            summaryList: summaryList,
            summaryTableData: summaryList,
            summaryComplete: true,
        });
        this.props.onSummaryComplete('bihourly', true);
    }

    /* Table Building ------------------------------ */

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            dataIsFiltered,
            endDate,
            startDate,
            system,
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders,
            summaryComplete,
        } = this.state;

        const dateString = convertStartEndDatesForFile(startDate, endDate);
        const isFilteredString = (dataIsFiltered) ? '-filtered' : '';

        // ReactTable headers and columns for Table
        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: '',
                        accessor: 'name',
                    },
                    {
                        Header: '12am - 2am',
                        accessor: 'hour_0-2',
                        style: tableStyles.right,

                    },
                    {
                        Header: '2am - 4am',
                        accessor: 'hour_2-4',
                        style: tableStyles.right,
                    },
                    {
                        Header: '4am - 6am',
                        accessor: 'hour_4-6',
                        style: tableStyles.right,
                    },
                    {
                        Header: '6am - 8am',
                        accessor: 'hour_6-8',
                        style: tableStyles.right,
                    },
                    {
                        Header: '8am - 10am',
                        accessor: 'hour_8-10',
                        style: tableStyles.right,
                    },
                    {
                        Header: '10am - 12pm',
                        accessor: 'hour_10-12',
                        style: tableStyles.right,
                    },
                    {
                        Header: '12pm - 2pm',
                        accessor: 'hour_12-14',
                        style: tableStyles.right,
                    },
                    {
                        Header: '2pm - 4pm',
                        accessor: 'hour_14-16',
                        style: tableStyles.right,
                    },
                    {
                        Header: '4pm - 6pm',
                        accessor: 'hour_16-18',
                        style: tableStyles.right,
                    },
                    {
                        Header: '6pm - 8pm',
                        accessor: 'hour_18-20',
                        style: tableStyles.right,
                    },
                    {
                        Header: '8pm - 10pm',
                        accessor: 'hour_20-22',
                        style: tableStyles.right,
                    },
                    {
                        Header: '10pm - 12am',
                        accessor: 'hour_22-24',
                        style: tableStyles.right,
                    }
                ]
            }
        ];

        return (
            <div>
                {summaryComplete &&
                <div className="reports-table-container">

                    {/* Table Header: Sales Summary */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container table-header-button-container">
                            {/* Export Sales Summary */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={'Sales-Summary-Bihourly-' + system + '-' + dateString + isFilteredString + '.csv'}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export Bihourly Summary
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIconSmall}/>
                            <span>Bihourly Summary</span>
                        </h3>
                    </div>

                    {/* Table: Bihourly Sales Summary Data */}
                    <ReactTable
                        key="table-sales-summary-bihourly"
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={11}
                        showPagination={false}
                        sortable={false}
                        filterable={false}
                        resizable={false}
                        getTrProps={(state, rowInfo) => {
                            let lastStyle = (rowInfo.original && rowInfo.original.is_last) ? styles.tRowLast : null;
                            let seriesStyle = (rowInfo.original && rowInfo.original.series) ? styles.tRow[rowInfo.original.series] : null;
                            if (seriesStyle && lastStyle) {
                                return {style: {...seriesStyle, ...lastStyle}};
                            } else if (seriesStyle && !lastStyle) {
                                return {style: seriesStyle};
                            } else if (!seriesStyle && lastStyle) {
                                return {style: lastStyle};
                            } else {
                                return {style: {}};
                            }
                        }}
                        minRows={11}
                        className="overflow no-print"
                    />
                    <ReactTable
                        key="table-sales-summary-bihourly-print"
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        resizable={false}
                        minRows={11}
                        className="print-only"
                    />
                </div>
                }
            </div>
        )
    }
}

SalesSummaryBihourlyReportTable.propTypes = {
    addField: PropTypes.bool,
    dataIsFiltered: PropTypes.bool,
    dataObject: PropTypes.object,
    endDate: PropTypes.string,
    offset: PropTypes.string.isRequired,
    onDisplayMessage: PropTypes.func,
    onSummaryComplete: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
};

SalesSummaryBihourlyReportTable.defaultProps = {
    addField: true,
    dataIsFiltered: false,
    dataObject: {},
    endDate: null,
    offset: null,
    startDate: null,
};

export default SalesSummaryBihourlyReportTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/SalesSummaryBihourlyReportTable.js